import {
  Box,
  Breadcrumbs,
  Button,
  Container,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import NoticePage from 'components/NoticePage';
import dayjs from 'dayjs';
import useNoticeDetail from 'hook/useNoticeDetail';
import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RootStyle } from './style';

export function NoticeModify() {
  const input = useRef({
    id: 1,
    created: '',
    modified: '',
    title: '',
    category: '',
    popup_period_start_date: '',
    popup_period_end_date: '',
    app_version: '',
    announcement_details: [
      {
        id: 1,
        created: '',
        modified: '',
        deleted: null,
        deleted_by_cascade: false,
        title: '',
        body: '',
        image: '',
      },
    ],
    button_name: '',
    link: '',
  }).current;
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const { id } = useParams();
  const { data } = useNoticeDetail(Number(id) || 1);
  return (
    <Container>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        mb={5}
        mt={4}
        spacing={2}
      >
        <Box flex={1}>
          <Typography variant='h4' gutterBottom>
            상세 정보
          </Typography>
        </Box>
        <Box>
          <Button
            variant='outlined'
            onClick={() => {
              console.log(input);
            }}
          >
            삭제
          </Button>
        </Box>
        <Box>
          <Button
            variant='contained'
            onClick={() => {
              console.log(input);
            }}
          >
            저장
          </Button>
        </Box>
      </Stack>
      <Stack direction='column'>
        <Stack direction='row' alignItems='center' mb={1} spacing={1}>
          <Box width={200}>
            <Typography>공지사항 제목</Typography>
          </Box>
          <Box width={400}>
            <TextField
              id='outlined-required'
              placeholder='제목을 입력하세요.'
              defaultValue='ㅁㄴㅇㄹ'
              value={input.title}
              onChange={(e) => {
                input.title = e.target.value;
              }}
              fullWidth
            />
          </Box>
        </Stack>
        <Stack direction='row' alignItems='center' mb={1} spacing={1}>
          <Box width={200}>
            <Typography>카테고리</Typography>
          </Box>
          <Box width={400}>
            <TextField
              id='outlined-required'
              placeholder='카테고리를 입력하세요'
              value={input.title}
              onChange={(e) => {
                input.title = e.target.value;
              }}
              fullWidth
            />
          </Box>
        </Stack>
        <Stack direction='row' alignItems='center' mb={1} spacing={1}>
          <Box width={200}>
            <Typography>팝업 노출기간</Typography>
          </Box>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box width={200}>
              <DatePicker
                views={['year', 'month', 'day']}
                minDate={new Date('2012-03-01')}
                maxDate={new Date('2050-06-01')}
                value={startDate}
                onChange={(newValue) => {
                  input.popup_period_start_date = dayjs(newValue).format(
                    'YYYY. M. D',
                  );
                  setStartDate(newValue || new Date());
                }}
                renderInput={(params) => (
                  <TextField {...params} helperText={null} />
                )}
              />
            </Box>
            <Box>-</Box>
            <Box width={200}>
              <DatePicker
                views={['year', 'month', 'day']}
                minDate={new Date('2012-03-01')}
                maxDate={new Date('2050-06-01')}
                value={endDate}
                onChange={(newValue) => {
                  input.popup_period_end_date = dayjs(newValue).format(
                    'YYYY. M. D',
                  );
                  setEndDate(newValue || new Date());
                }}
                renderInput={(params) => (
                  <TextField {...params} helperText={null} />
                )}
              />
            </Box>
          </LocalizationProvider>
        </Stack>
        <Stack direction='row' alignItems='center' mb={1} spacing={1}>
          <Box width={200}>
            <Typography>앱 버전</Typography>
          </Box>
          <Box width={400}>
            <TextField
              id='outlined-required'
              placeholder='3.4.0'
              defaultValue=''
              onChange={(e) => {
                input.app_version = e.target.value;
              }}
              fullWidth
            />
          </Box>
        </Stack>
        <Stack direction='row' alignItems='center' mb={1} spacing={1}>
          <Box width={200}>
            <Typography>[선택] 버튼 링크</Typography>
          </Box>
          <Box width={150}>
            <TextField
              id='outlined-required'
              defaultValue=''
              placeholder='버튼명'
              onChange={(e) => {
                input.button_name = e.target.value;
              }}
              fullWidth
            />
          </Box>
          <Box width={242}>
            <TextField
              id='outlined-required'
              defaultValue=''
              placeholder='URL를 입력하세요.'
              onChange={(e) => {
                input.link = e.target.value;
              }}
              fullWidth
            />
          </Box>
        </Stack>
      </Stack>
      <Stack>
        {[1, 2, 3].map((i, index) => (
          <NoticePage key={i} index={index} />
        ))}
      </Stack>
      <Stack mb={10}>
        <Button
          variant='outlined'
          onClick={() => {
            console.log(input);
          }}
          fullWidth
        >
          페이지 추가
        </Button>
      </Stack>
    </Container>
  );
}
